const UPDATE_PERFECT_SHOTS_RESULTS_ENDPOINT = '/worklist/update-perfect-shot-results';

export class WorklistPerfectShot extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init()
    {
        this.assembleBar();
        this.initEventListeners();
    }

    assembleBar()
    {
    }

    initEventListeners()
    {
        const psHeaderBadges = this.querySelectorAll('.perfect-shot-header-badge');
        psHeaderBadges.forEach(badge => {
            badge.addEventListener('click', this.psFilterClicked.bind(this));
        });

        const psFooterBadges = document.body.querySelectorAll('.perfect-shot-footer-badge');
        psFooterBadges.forEach(badge => {
            badge.addEventListener('click', this.psFilterClicked.bind(this));
        });

        const psFooterItems = this.querySelectorAll('.ps-footer-item');
        psFooterItems.forEach(item => {
            item.addEventListener('click', this.psFilterClicked.bind(this));
        });

        document.body.addEventListener('five-minute-mark', this.handleFiveMinuteMark.bind(this));

        // VETALL-26983: chip clicks must not bubble into any case-card click action
        document.body.addEventListener('click', (event) => {
            const chip = event.target.closest('.perfect-shot-quality');
            if (chip) {
                event.stopPropagation();
            }
        });

    }

    handleFiveMinuteMark(event)
    {
        this.updatePerfectShotResults();
    }


    psFilterClicked(event)
    {
        const badge = event.currentTarget;
        const cases = badge.getAttribute('data-cases');
        if (cases) {
            const caseFilter = document.querySelector('#id_case_id');
            if (caseFilter) {
                caseFilter.value = cases;
                const modalityFilter = document.querySelector('#id_modality');
                if (modalityFilter) {
                    modalityFilter.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        } else if (badge.classList.contains('perfect-shot-all-badge')) {
            const caseFilter = document.querySelector('#id_case_id');
            if (caseFilter) {
                caseFilter.value = '';
                const modalityFilter = document.querySelector('#id_modality');
                if (modalityFilter) {
                    modalityFilter.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        }
    }

    updatePerfectShotResults()
    {
        const worklistElem = document.querySelector('work-list');
        if (worklistElem) {
            const formData = worklistElem.getWorklistFormData();
            const worklistDisplayedCaseIds = worklistElem.getWorklistDisplayedCases();
            formData.append('displayed_case_ids', worklistDisplayedCaseIds.join(','));
            
            fetch(UPDATE_PERFECT_SHOTS_RESULTS_ENDPOINT, {
                method: 'POST',
                body: formData
            }).then(response => {
                if (response.ok) {
                    response.json().then(data => {
                        const perfectShotResults = data.perfectShotResults;
                        // update the badge counts
                        const warningBadge = this.querySelector('.perfect-shot-warning-badge');
                        if (warningBadge) {
                            warningBadge.setAttribute('data-cases', [...perfectShotResults.warnings, ...perfectShotResults.failures].join(','));

                            const countElem = warningBadge.querySelector('.badge-count');
                            if (countElem) {
                                countElem.textContent = perfectShotResults.warnings.length + perfectShotResults.failures.length;
                            }
                        }
                        const failedBadge = this.querySelector('.perfect-shot-fail-badge');
                        if (failedBadge) {
                            failedBadge.setAttribute('data-cases', perfectShotResults.failures.join(','));
                            const countElem = failedBadge.querySelector('.badge-count');
                            if (countElem) {
                                countElem.textContent = perfectShotResults.failures.length;
                            }
                        }

                        const psFooter = worklistElem.querySelector('.worklist-perfect-shot-footer');
                        if (psFooter) {
                            const totalCountElem = psFooter.querySelector('.ps-total-count .ps-footer-count-number');
                            if (totalCountElem) {
                                totalCountElem.textContent = `${perfectShotResults.total_cases} Cases`;
                            }
                            const passCountElem = psFooter.querySelector('.ps-footer-pass-count');
                            if (passCountElem) {
                                passCountElem.dataset.cases = perfectShotResults.passed.join(',');
                                const passCountNumberElem = passCountElem.querySelector('.ps-footer-count-number');
                                if (passCountNumberElem) {
                                    passCountNumberElem.textContent = perfectShotResults.passed.length;
                                }
                            }
                            const warningCountElem = psFooter.querySelector('.ps-footer-warning-count');
                            if (warningCountElem) {
                                warningCountElem.dataset.cases = perfectShotResults.warnings.join(',');
                                const warningCountNumberElem = warningCountElem.querySelector('.ps-footer-count-number');
                                if (warningCountNumberElem) {
                                    warningCountNumberElem.textContent = perfectShotResults.warnings.length;
                                }
                            }
                            const failCountElem = psFooter.querySelector('.ps-footer-fail-count');
                            if (failCountElem) {
                                failCountElem.dataset.cases = perfectShotResults.failures.join(',');
                                const failedCountElem = failCountElem.querySelector('.ps-footer-count-number');
                                if (failedCountElem) {
                                    failedCountElem.textContent = perfectShotResults.failures.length;
                                }
                            }
                            const unreviewedCountElem = psFooter.querySelector('.ps-footer-unreviewed-count');
                            if (unreviewedCountElem) {
                                unreviewedCountElem.dataset.cases = perfectShotResults.unreviewed.join(',');
                                const unreviewedCountNumberElem = unreviewedCountElem.querySelector('.ps-footer-count-number');
                                if (unreviewedCountNumberElem) {
                                    unreviewedCountNumberElem.textContent = perfectShotResults.unreviewed.length;
                                }
                            }
                        }
                        this.updateCaseCardChips(perfectShotResults.case_results);
                    });
                } else {
                    console.error('Failed to update perfect shot results');
                }
            }).catch(error => {
                console.error('Error updating perfect shot results:', error);
            });
        }
    }

    updateCaseCardChips(caseResults)
    {
        if (!caseResults) {
            return;
        }
        Object.keys(caseResults).forEach(caseId => {
            const card = document.querySelector(`.case-card-container[data-case="${caseId}"]`);
            if (!card) {
                return;
            }
            const chip = card.querySelector('.perfect-shot-quality');
            // Only update chips already rendered server-side (covers Pending -> complete).
            // Cases with no chip at render get theirs on the next full Worklist load.
            if (!chip) {
                return;
            }
            const quality = caseResults[caseId];
            chip.classList.remove('ps-pass', 'ps-warning', 'ps-fail', 'ps-pending');
            chip.classList.add(`ps-${quality}`);
            // Rebuild icon + label to match case.blade.php:272-283. Preserves the
            // anchor element (href/title/target and any bound listeners survive).
            chip.innerHTML = this.chipInnerHtml(quality);
        });
    }

    chipInnerHtml(quality)
    {
        switch (quality) {
            case 'pass':
                return '<vetology-svg data-svg="check" width="14" height="14"></vetology-svg><span class="label">Pass</span>';
            case 'warning':
                return '<vetology-svg data-svg="warning" width="14" height="14"></vetology-svg><span class="label">Warning</span>';
            case 'fail':
                return '<vetology-svg data-svg="dangerous" width="14" height="14"></vetology-svg><span class="label">Fail</span>';
            case 'pending':
                return '<span class="label">Pending</span>';
            default:
                return '';
        }
    }

}

customElements.define('worklist-perfect-shot', WorklistPerfectShot);